.card {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--md-surface-container-lowest);
  border: 2px solid var(--md-outline-variant);
  border-radius: var(--shape-sm);
  cursor: pointer;
  font-family: inherit;
  transition: all var(--motion-duration-short3);
  text-align: start;
}

.card:hover {
  background: var(--md-surface-container-low);
  border-color: var(--md-primary);
}

.card:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

.card:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.card:disabled:hover {
  background: var(--md-surface-container-lowest);
  border-color: var(--md-outline-variant);
}

.cardSelected {
  border-color: var(--md-primary);
  background: var(--md-primary-container, rgba(0, 100, 255, 0.06));
}

.cardSelected:hover {
  background: var(--md-primary-container, rgba(0, 100, 255, 0.1));
}

.cardIncluded {
  border-color: var(--status-success);
  background: var(--status-success-container);
  cursor: default;
}

.cardIncluded:hover {
  background: var(--status-success-container);
  border-color: var(--status-success);
}

.cardIncluded .check {
  border-color: var(--status-success);
  background: var(--status-success);
}

.cardIncluded .checkIcon {
  stroke: #fff;
  opacity: 1;
}

.cardIncluded .price {
  color: var(--status-success);
}

.badgeIncluded {
  color: var(--status-success);
  background: var(--status-success-container);
}

.includedText {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--status-success);
}

.check {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.25rem;
  border: 2px solid var(--md-outline);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color var(--motion-duration-short3),
    background var(--motion-duration-short3);
  margin-top: 0.125rem;
}

.iconSlot {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.125rem;
}

.cardSelected .check {
  border-color: var(--md-primary);
  background: var(--md-primary);
}

.checkIcon {
  width: 0.75rem;
  height: 0.75rem;
  fill: none;
  stroke: var(--md-on-primary);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
}

.cardSelected .checkIcon {
  opacity: 1;
}

.info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.titleRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
}

.title {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-weight: 600;
  color: var(--text);
}

.badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.625rem;
  font-weight: 600;
  color: var(--md-primary);
  background: var(--md-primary-container, rgba(0, 100, 255, 0.08));
  padding: 0.125rem 0.5rem;
  border-radius: var(--shape-full);
  white-space: nowrap;
}

.benefit {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--text-mid);
}

.how {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--text-light);
}

.desc {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--text-mid);
  margin: 0;
}

.disabledText {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--text-light);
  font-style: italic;
}

.price {
  font: var(--type-title-md);
  letter-spacing: var(--tracking-title-md);
  font-weight: 700;
  color: var(--md-primary);
  white-space: nowrap;
  flex-shrink: 0;
}

/* Skeleton */
.skeleton {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--md-surface-container-lowest);
  border: 2px solid var(--md-outline-variant);
  border-radius: var(--shape-sm);
}
